const lineClampStyle = (lineClamp) =>
  `
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: ${lineClamp};
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
`;

const getWidthFromGridColumn = (gridColumn) =>
  `calc(${gridColumn} * 32px + ${gridColumn - 1} * 16px)`;

export default { lineClampStyle, getWidthFromGridColumn };
